export default __webpack_public_path__ + "static/media/justice-of-the-peace.inline.548feb7f.svg";